import { render, staticRenderFns } from "./CriticalSpareReport.vue?vue&type=template&id=e59b81ac"
import script from "./CriticalSpareReport.vue?vue&type=script&lang=js"
export * from "./CriticalSpareReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports